import { actingFor, setActingFor } from '../api/client';
import { useT } from '../i18n/i18n';

export default function ActingBanner() {
  const t = useT();
  const a = actingFor();
  if (!a) return null;
  return (
    <div className="acting-banner" role="status">
      <span>{t('You are working for')} <strong>{a.family}</strong> {t('on {learners}.', { learners: a.learners.join(` ${t('and')} `) })} {t('The family sees every change you make.')}</span>
      <button type="button" className="btn secondary" onClick={() => { setActingFor(null); window.location.assign('/assist/expert'); }}>
        {t('Stop working for this family')}
      </button>
    </div>
  );
}
